export const slugify = (value: string) => {
    if (!value) return '';

    const normalized = value
        .toLowerCase()
        .trim()
        .replace(/ae/g, 'æ')
        .replace(/oe/g, 'ø')
        .replace(/aa/g, 'å')
        // Preserve Danish letters while still removing other diacritics.
        .replace(/æ/g, '__AE__')
        .replace(/ø/g, '__OE__')
        .replace(/å/g, '__AA__')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/__AE__/g, 'æ')
        .replace(/__OE__/g, 'ø')
        .replace(/__AA__/g, 'å')
        .replace(/[^a-z0-9æøå\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-+|-+$/g, '');

    return normalized;
};

export const buildGalleryPath = (gallery: { id: string | number; title: string }) => {
    const slug = slugify(gallery.title);
    return slug ? `/gallery/${gallery.id}/${slug}` : `/gallery/${gallery.id}`;
};
